import React from 'react'
import Image from 'next/image'
import {
  MAYBE_UNPAID_CHALLANS,
  UNPAID_CHALLANS,
  UNPAID_CHALLAN_BANNER_PNG,
  DynamicChallan,
  CHALLAN_SLICE_RANGE,
} from './constants'
import styles from './whatsappChallan.module.scss'
import { ChallanCard } from './ChallanCard'

interface PendingChallanWidgetProps {
  isVerified: boolean
  dynamicChallan: DynamicChallan
}

const PendingChallanWidget: React.FC<PendingChallanWidgetProps> = ({ isVerified, dynamicChallan }) =>
  isVerified ? (
    <div>
      <p className={styles.unpaidChallanHeading}>{UNPAID_CHALLANS}</p>
      <div className={styles.cardStackWrapper}>
        {dynamicChallan
          ?.slice(...CHALLAN_SLICE_RANGE)
          .map((item, idx, arr) => (
            <ChallanCard key={idx} index={idx} item={item} showImage={idx === arr.length - 1} />
          ))}
      </div>
    </div>
  ) : (
    <div className={styles.unpaidChallanContainer}>
      <p className={styles.unpaidChallanHeading}>{MAYBE_UNPAID_CHALLANS}</p>
      <Image
        width={100}
        height={100}
        src={UNPAID_CHALLAN_BANNER_PNG}
        alt="Unpaid challan banner"
        className={styles.unpaidBannerImage}
      />
    </div>
  )
export default PendingChallanWidget
